import React from 'react';
import clsx from 'clsx';
import Hexagon from '@components/Hexagon';
import { theme } from '../../../tailwind.config';
import { TxStatus, TxStep } from '@types';
import Icon from '@components/Icon';

interface Props {
  children: React.ReactElement;
  txnStatus: TxStatus;
  txnStep: TxStep;
  loading: boolean;
  txnErrorMessage?: string;
}

function TransactionInfoContainer({
  children,
  txnStatus,
  txnStep,
  loading,
  txnErrorMessage,
}: Props) {
  const displayHexagonChildren = () => {
    if (txnErrorMessage) return '!';

    if (txnStatus === TxStatus.pending) {
      if (txnStep === TxStep.deposit) return 1;
      if (txnStep === TxStep.transfer) return 2;
    }

    if (txnStatus === TxStatus.fulfilled) {
      return <Icon.Check title={TxStatus.fulfilled} />;
    }

    return null;
  };

  return (
    <>
      <div className="bg-white10 text-white rounded-lg tablet:w-4/5 mobile:w-full mx-auto">
        <div className="flex content-center text-body p-2">
          <div className="relative h-full text-left mr-1">
            <Hexagon
              size={20}
              hexagonColor={
                txnErrorMessage ? theme.colors.red : theme.colors.blue
              }
              className={clsx('', {
                'animate-spin-ease-in-out': loading,
              })}
            >
              {displayHexagonChildren()}
            </Hexagon>
          </div>
          {children}
        </div>
      </div>
      {txnErrorMessage && (
        <p className="text-red text-microLight tablet:w-4/5 mobile:w-full mx-auto text-left mt-1">
          {txnErrorMessage}
        </p>
      )}
    </>
  );
}

export default TransactionInfoContainer;
